module.exports = {
  'lang': 'zh-cn',
  'total': '共',
  'items': '条',
  'show': '显示',
  'goto': '跳至',
  'page': '页',
  'ok': '确认',
  'zh-cn': {
    'total': '共',
    'items': '条',
    'show': '显示',
    'goto': '跳至',
    'page': '页',
    'ok': '确认'
  },
  'en-us': {
    'total': 'Total',
    'items': 'items',
    'show': 'Show',
    'goto': 'Goto',
    'page': 'Page',
    'ok': 'OK'
  },
  'zh-tw': {
    'total': '共',
    'items': '條',
    'show': '顯示',
    'goto': '跳至',
    'page': '頁',
    'ok': '確認'
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-pagination/src/i18n.js